import React from "react";
import { List as BricksList, IconIconSwap, ListItem } from "@red-digital/bricks";

import styles from "./List.module.scss";

type ListItem = {
  heading: React.ReactNode;
  support?: React.ReactNode;
  icon?: React.FC;
};

interface ListProps {
  items: ListItem[];
}

export const List: React.FC<ListProps> = ({ items = [] }) => {
  if (!items?.length) return null;

  return (
    <BricksList>
      {items.map((item, index) => (
        <ListItem
          key={index}
          className={styles.listItem}
          heading={{ type: "h2", children: item.heading }}
          support={{ children: item.support }}
          icon={
            item.icon
              ? {
                  component: item.icon,
                  position: "left",
                }
              : undefined
          }
        />
      ))}
    </BricksList>
  );
};
